import React, { useState } from "react"
import * as layouts from "layouts"
import * as section from "."
import * as brandguide from "brandguide"
import { compliance as validations } from "brandguide/validations"
import * as md5x from "md5x"

export const Steps = {
	SELECTION: 0,
	RESULT: 1,
}

export function Container(props: layouts.containers.ContainerProps): JSX.Element {
	const { ...rest } = props
	const cache = brandguide.cache.useCached()

	const _compliance = brandguide.api.zeros.guide.guideComplianceZero(cache.guide.guide?.compliance)

	const curstep = () => {
		switch (false) {
			case validations.valid.selection(_compliance):
				return Steps.SELECTION
			default:
				return Steps.RESULT
		}
	}

	const [step, setStep] = useState(curstep)
	const [loading, setLoading] = useState(false)

	const handleOnStep = (step: number, data: brandguide.api.GuideCompliance | undefined) => {
		if (!data) {
			setStep(step)
			return
		}

		const guide = { ...cache.guide.guide, compliance: data }
		const md5 = md5x.string(JSON.stringify(guide))

		if (md5 === cache.md5) {
			setStep(step)
			return
		}

		setLoading(true)
		cache.store({ ...cache, guide: { ...cache.guide, guide: guide } }).finally(() => {
			setStep(step)
			setLoading(false)
		})
	}

	return (
		<layouts.Flex overflowY="auto" {...rest}>
			<layouts.loading.screen flex="1" loading={loading}>
				{step === Steps.SELECTION && <section.Selecting onChange={handleOnStep} />}
				{step === Steps.RESULT && <section.Result onChange={handleOnStep} />}
			</layouts.loading.screen>
		</layouts.Flex>
	)
}

Container.defaultProps = {
	flexDirection: "column",
	flex: "1",
	mb: "25px",
}

export default Container
